<template>
  <ul class="link-list">
    <li v-for="(link, index) in linksFiltered" :key="index">
      <VuepalLink target="blank" :class="linkClass" :to="link.url?.path"
        ><span>{{ link.title }}</span></VuepalLink
      >
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

interface Link {
  title: string
  url: {
    path: string
  }
}

const props = defineProps({
  links: {
    type: Array as PropType<Link[] | any>,
    default: () => [],
  },
  linkClass: {
    type: String,
    default: 'link',
  },
})

const linksFiltered = computed(() =>
  props.links.filter((v: Link) => v?.url?.path),
)
</script>

<style lang="scss">
.link-list {
  .tag {
    /* Prevent horizontal overflow scrolling. */
    max-width: calc(100vw - 2rem);
    @include tablet {
      max-width: 16rem;
    }
    span {
      white-space: nowrap;
      overflow: hidden;
      min-width: 0;
      text-overflow: ellipsis;
    }
  }
}
</style>
